const USE_PROXY = true;
const PROXY_URL = '/api/1inch';

const CHAIN_IDS = {
  'ETHEREUM': 1,
  'ARBITRUM': 42161,
  'OPTIMISM': 10,
  'BASE': 8453
};

const TOKEN_ADDRESSES = {
  'ETHEREUM': {
    'ETH': '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
    'WETH': '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
    'WBTC': '0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599',
    'USDC': '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
    'USDT': '0xdAC17F958D2ee523a2206206994597C13D831ec7',
    'DAI': '0x6B175474E89094C44Da98b954EedeAC495271d0F',
    'LINK': '0x514910771AF9Ca656af840dff83E8264EcF986CA',
    'UNI': '0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984',
    'AAVE': '0x7Fc66500c84A76Ad7e9c93437bFc5Ac33E2DDaE9',
    'MKR': '0x9f8F72aA9304c8B593d555F12eF6589cC3A579A2',
    'CRV': '0xD533a949740bb3306d119CC777fa900bA034cd52',
    'LDO': '0x5A98FcBEA516Cf06857215779Fd812CA3beF1B32',
    'SNX': '0xC011a73ee8576Fb46F5E1c5751cA3B9Fe0af2a6F',
    'COMP': '0xc00e94Cb662C3520282E6f5717214004A7f26888',
    'SUSHI': '0x6B3595068778DD592e39A122f4f5a5cF09C90fE2'
  },
  'ARBITRUM': {
    'ETH': '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
    'WETH': '0x82aF49447D8a07e3bd95BD0d56f35241523fBab1',
    'WBTC': '0x2f2a2543B76A4166549F7aaB2e75Bef0aefC5B0f',
    'USDC': '0xaf88d065e77c8cC2239327C5EDb3A432268e5831',
    'USDT': '0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9',
    'DAI': '0xDA10009cBd5D07dd0CeCc66161FC93D7c9000da1',
    'LINK': '0xf97f4df75117a78c1A5a0DBb814Af92458539FB4',
    'UNI': '0xFa7F8980b0f1E64A2062791cc3b0871572f1F7f0',
    'ARB': '0x912CE59144191C1204E64559FE8253a0e49E6548',
    'AAVE': '0xba5DdD1f9d7F570dc94a51479a000E3BCE967196',
    'CRV': '0x11cDb42B0EB46D95f990BeDD4695A6e3fA034978',
    'SUSHI': '0xd4d42F0b6DEF4CE0383636770eF773390d85c61A'
  },
  'OPTIMISM': {
    'ETH': '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
    'WETH': '0x4200000000000000000000000000000000000006',
    'WBTC': '0x68f180fcCe6836688e9084f035309E29Bf0A2095',
    'USDC': '0x0b2C639c533813f4Aa9D7837CAf62653d097Ff85',
    'USDT': '0x94b008aA00579c1307B0EF2c499aD98a8ce58e58',
    'DAI': '0xDA10009cBd5D07dd0CeCc66161FC93D7c9000da1',
    'LINK': '0x350a791Bfc2C21F9Ed5d10980Dad2e2638ffa87',
    'UNI': '0x6fd9d7AD17242c41f7131d257212c54A0e816691',
    'OP': '0x4200000000000000000000000000000000000042',
    'SNX': '0x8700dAec35aF8Ff88c16BdF0418774CB3D7599B4',
    'AAVE': '0x76FB31fb4af56892A25e32cFC43De717950c9278'
  },
  'BASE': {
    'ETH': '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
    'WETH': '0x4200000000000000000000000000000000000006',
    'USDC': '0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913',
    'DAI': '0x50c5725949A6F0c72E6C4a641F24049A917DB0Cb',
    'AAVE': '0x4e65fE4DbA92790696d040ac24Aa414708F5c0AB'
  }
};

const ROUTER_ADDRESSES = {
  'ETHEREUM': '0x1111111254EEB25477B68fb85Ed929f73A960582',
  'ARBITRUM': '0x1111111254EEB25477B68fb85Ed929f73A960582',
  'OPTIMISM': '0x1111111254EEB25477B68fb85Ed929f73A960582',
  'BASE': '0x1111111254EEB25477B68fb85Ed929f73A960582'
};

class OneInchService {
  constructor() {
    this.useProxy = USE_PROXY;
  }

  async fetchAPI(endpoint, params = {}, chain = null) {
    let chainId;
    
    if (chain) {
      chainId = this.getChainId(chain);
    } else {
      chainId = params.chainId || 1;
      delete params.chainId;
    }

    const queryString = new URLSearchParams(params).toString();
    const url = `${PROXY_URL}/${chainId}${endpoint}${queryString ? '?' + queryString : ''}`;

    console.log('Fetching from Flask proxy:', url);
    console.log('Params:', params);

    const response = await fetch(url, {
      headers: {
        'accept': 'application/json'
      }
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error('API Error Response:', errorText);
      let error;
      try {
        error = JSON.parse(errorText);
      } catch {
        error = { description: errorText };
      }
      throw new Error(error.description || error.error || `API request failed: ${response.status}`);
    }

    return response.json();
  }

  getTokenAddress(chain, symbol) {
    return TOKEN_ADDRESSES[chain]?.[symbol] || null;
  }

  getChainId(chain) {
    return CHAIN_IDS[chain] || 1;
  }

  getRouterAddress(chain) {
    return ROUTER_ADDRESSES[chain] || ROUTER_ADDRESSES['ETHEREUM'];
  }

  async getQuote(fromToken, toToken, amount, chain = 'ETHEREUM', slippage = 1) {
    const chainId = this.getChainId(chain);
    const src = this.getTokenAddress(chain, fromToken);
    const dst = this.getTokenAddress(chain, toToken);

    if (!src || !dst) {
      throw new Error(`Token not supported: ${fromToken} or ${toToken} on ${chain}`);
    }

    const decimals = ['USDC', 'USDT', 'BUSD', 'FRAX'].includes(fromToken) ? 6 : 
                     fromToken === 'WBTC' ? 8 : 18;
    const amountInWei = this.toWei(amount, decimals);

    const params = {
      chainId,
      src,
      dst,
      amount: amountInWei,
      includeTokensInfo: true,
      includeProtocols: true
    };

    try {
      const data = await this.fetchAPI('/quote', params);
      
      const toDecimals = ['USDC', 'USDT', 'BUSD', 'FRAX'].includes(toToken) ? 6 : 
                         toToken === 'WBTC' ? 8 : 18;
      const toAmount = this.fromWei(data.dstAmount || data.toAmount, toDecimals);

      return {
        fromToken,
        toToken,
        fromAmount: amount,
        toAmount,
        estimatedGas: data.estimatedGas || data.gas,
        protocols: data.protocols || []
      };
    } catch (error) {
      console.error('Quote error:', error);
      throw error;
    }
  }

  async getSwapTransaction(fromToken, toToken, amount, fromAddress, chain = 'ETHEREUM', slippage = 1) {
    const chainId = this.getChainId(chain);
    const src = this.getTokenAddress(chain, fromToken);
    const dst = this.getTokenAddress(chain, toToken);

    console.log('=== SWAP REQUEST DEBUG ===');
    console.log('Input amount:', amount);
    console.log('From token:', fromToken);
    console.log('To token:', toToken);
    console.log('Chain:', chain);
    console.log('Chain ID:', chainId);
    console.log('From address:', fromAddress);

    if (!src || !dst) {
      throw new Error(`Token not supported: ${fromToken} or ${toToken} on ${chain}`);
    }

    let decimals = 18;
    if (['USDC', 'USDT', 'BUSD', 'FRAX'].includes(fromToken)) {
      decimals = 6;
    } else if (fromToken === 'WBTC') {
      decimals = 8;
    }

    const amountInWei = this.toWei(amount, decimals);
    
    console.log('Decimals:', decimals);
    console.log('Amount in wei:', amountInWei);
    console.log('=========================');

    const params = {
      chainId,
      src,
      dst,
      amount: amountInWei,
      from: fromAddress,
      slippage,
      disableEstimate: true,
      allowPartialFill: false
    };

    try {
      const swap = await this.fetchAPI('/swap', params);
      
      console.log('=== SWAP RESPONSE ===');
      console.log('To address:', swap.tx.to);
      console.log('Value:', swap.tx.value);
      console.log('Gas:', swap.tx.gas);
      console.log('====================');
      
      const toDecimals = ['USDC', 'USDT', 'BUSD', 'FRAX'].includes(toToken) ? 6 : 
                         toToken === 'WBTC' ? 8 : 18;
      
      return {
        to: swap.tx.to,
        data: swap.tx.data,
        value: swap.tx.value || '0',
        gas: swap.tx.gas,
        gasPrice: swap.tx.gasPrice,
        toAmount: this.fromWei(swap.dstAmount, toDecimals)
      };
    } catch (error) {
      console.error('Swap transaction error:', error);
      throw error;
    }
  }

  async checkNeedsApproval(token, walletAddress, chain = 'ETHEREUM') {
    const tokenAddress = this.getTokenAddress(chain, token);

    if (!tokenAddress || token === 'ETH') {
      return false;
    }

    const params = {
      tokenAddress,
      walletAddress
    };

    try {
      const result = await this.fetchAPI('/approve/allowance', params, chain);
      const allowance = result.allowance || '0';
      
      console.log(`Approval check for ${token} on ${chain}:`, {
        tokenAddress,
        allowance,
        needsApproval: allowance === '0' || parseInt(allowance) === 0
      });
      
      return allowance === '0' || parseInt(allowance) === 0;
    } catch (error) {
      console.error('Allowance check error:', error);
      return true;
    }
  }

  async getApprovalTransaction(token, chain = 'ETHEREUM') {
    const tokenAddress = this.getTokenAddress(chain, token);

    console.log(`Getting approval transaction for ${token} on ${chain}:`, {
      token,
      chain,
      tokenAddress,
      availableTokens: Object.keys(TOKEN_ADDRESSES[chain] || {})
    });

    if (!tokenAddress) {
      throw new Error(`Token ${token} not found on ${chain}. Available tokens: ${Object.keys(TOKEN_ADDRESSES[chain] || {}).join(', ')}`);
    }

    const params = {
      tokenAddress
    };

    try {
      const result = await this.fetchAPI('/approve/transaction', params, chain);
      
      console.log('Approval transaction received:', result);
      
      return {
        to: result.to,
        data: result.data,
        value: result.value || '0',
        gasPrice: result.gasPrice
      };
    } catch (error) {
      console.error('Approval transaction error:', error);
      throw error;
    }
  }

  toWei(amount, decimals = 18) {
    console.log(`toWei - Input: ${amount}, Decimals: ${decimals}`);
    
    const amountStr = amount.toString();
    const [integerPart, decimalPart = ''] = amountStr.split('.');
    
    const paddedDecimal = decimalPart.padEnd(decimals, '0');
    
    if (paddedDecimal.length > decimals) {
      throw new Error('Too many decimal places');
    }
    
    const result = integerPart + paddedDecimal;
    const cleanResult = result.replace(/^0+/, '') || '0';
    
    console.log(`toWei - Integer: ${integerPart}, Decimal: ${decimalPart}`);
    console.log(`toWei - Padded decimal: ${paddedDecimal}`);
    console.log(`toWei - Combined: ${result}`);
    console.log(`toWei - Clean result: ${cleanResult}`);
    
    return cleanResult;
  }

  fromWei(amount, decimals = 18) {
    const amountStr = amount.toString().padStart(decimals + 1, '0');
    const integerPart = amountStr.slice(0, -decimals) || '0';
    const decimalPart = amountStr.slice(-decimals);
    return parseFloat(`${integerPart}.${decimalPart}`);
  }
}

export default new OneInchService();